import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-edit-notification',
  templateUrl: './edit-notification.component.html',
  styleUrls: ['./edit-notification.component.scss']
})
export class EditNotificationComponent implements OnInit {
  notificationId:any;
  notificationData={
    title:'',
    description:'',
    joiningLink:'',
    isRead:''
    
  };
  constructor(private activatedroute:ActivatedRoute,
    private apiService:ApiService) { }

  ngOnInit(): void { this.activatedroute.paramMap.subscribe(params => { 
    this.notificationId = params.get('id'); 
    console.log('userId',this.notificationId)
});
  }
  getNotificationByUserId(){
    this.apiService.getNotificationByUserId(this.notificationId).subscribe((res:any)=>{
      
        console.log('notificationId',res)
        this.notificationData =res.data 
      })
    
    }
     submit(){
     if(this.notificationId){
      this.apiService.updateNotification(this.notificationId,this.notificationData).subscribe((res:any)=>{
      
          console.log('update notification',res)
           
        
        
      })
    }
     else{
       alert('Something went Wrong!!!')
     }
  }
}
